/* EVENTS */
export const GET_CUSTOMER = "GET_CUSTOMER"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL"

export const GET_CUSTOMER_SELECT_LISTING = "GET_CUSTOMER_SELECT_LISTING"
export const GET_CUSTOMER_SELECT_LISTING_SUCCESS = "GET_CUSTOMER_SELECT_LISTING_SUCCESS"
export const GET_CUSTOMER_SELECT_LISTING_FAIL = "GET_CUSTOMER_SELECT_LISTING_FAIL"

export const GET_CUSTOMER_DETAILS = "GET_CUSTOMER_DETAILS"
export const GET_CUSTOMER_DETAILS_SUCCESS = "GET_CUSTOMER_DETAILS_SUCCESS"
export const GET_CUSTOMER_DETAILS_FAIL = "GET_CUSTOMER_DETAILS_FAIL"

export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER"
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
export const ADD_CUSTOMER_FAIL = "ADD_CUSTOMER_FAIL"

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS"
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL"

export const DELETE_CUSTOMER = "DELETE_CUSTOMER"
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS"
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL"

export const EXPORT_CUSTOMER = "EXPORT_CUSTOMER"
export const EXPORT_CUSTOMER_SUCCESS = "EXPORT_CUSTOMER_SUCCESS"
export const EXPORT_CUSTOMER_FAIL = "EXPORT_CUSTOMER_FAIL"

export const ADD_CUSTOMER_POINTS = "ADD_CUSTOMER_POINTS"
export const ADD_CUSTOMER_POINTS_SUCCESS = "ADD_CUSTOMER_POINTS_SUCCESS"
export const ADD_CUSTOMER_POINTS_FAIL = "ADD_CUSTOMER_POINTS_FAIL"


export const ADD_CUSTOMER_VOUCHERS = "ADD_CUSTOMER_VOUCHERS"
export const ADD_CUSTOMER_VOUCHERS_SUCCESS = "ADD_CUSTOMER_VOUCHERS_SUCCESS"
export const ADD_CUSTOMER_VOUCHERS_FAIL = "ADD_CUSTOMER_VOUCHERS_FAIL"

export const RESET_CUSTOMER_STATE = 'RESET_CUSTOMER_STATE';
export const RESET_CUSTOMER_ATTACHMENT_STATE = 'RESET_CUSTOMER_ATTACHMENT_STATE';
